import { __awaiter } from '../../_virtual/_tslib.js';
import { options } from './option.js';
import { variableTypeDetection } from '../utils/unils.js';
import { processTask } from '../utils/process.js';

/**
 *  mirror 生命周期插件管理类
 *  before after 2个钩子，
 *  type 对应各种类型事件,
 *  before 钩子 需要返回 true or false , false的话不执行后续Mirror逻辑
 */
let mirrorPluginsIns = null;
class MirrorPluginHandler {
    before(type, data) {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            // 多组插件的情况
            if (options.plugins && variableTypeDetection.isArray(options.plugins)) {
                try {
                    const arrPlugin = options.plugins;
                    const losRes = yield processTask(arrPlugin, 'before', { type, data }).start();
                    let [lastPlugin] = losRes.slice(-1);
                    // 最后一个plugin返回的true or false 决定是否继续执行
                    resolve(lastPlugin);
                }
                catch (error) {
                    console.warn('bili-mirror:plugin function before hook error,please check');
                    resolve(true);
                }
            }
            else if (options.plugins && options.plugins.mirrorHandleBefore) {
                // 单个插件
                try {
                    options.plugins.mirrorHandleBefore(type, data).then((res) => {
                        resolve(res);
                    });
                }
                catch (error) {
                    console.warn('bili-mirror:plugin function before hook error,please check');
                    resolve(true);
                }
            }
            else {
                // 没有插件,默认返回true
                resolve(true);
            }
        }));
    }
    after(type, data) {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            // 多个plugin after
            if (options.plugins && variableTypeDetection.isArray(options.plugins)) {
                try {
                    const arrPlugin = options.plugins;
                    yield processTask(arrPlugin, 'after', { type, data }).start();
                    resolve();
                }
                catch (error) {
                    console.warn('bili-mirror:plugin function after hook error,please check');
                    resolve();
                }
            }
            else if (options.plugins && options.plugins.mirrorHandleAfter) {
                // 单个after
                try {
                    options.plugins.mirrorHandleAfter(type, data).then(() => {
                        resolve();
                    });
                }
                catch (error) {
                    console.warn('bili-mirror:plugin function after hook error,please check');
                    resolve();
                }
            }
            else {
                resolve();
            }
        }));
    }
}
if (!mirrorPluginsIns) {
    mirrorPluginsIns = new MirrorPluginHandler();
}

export { mirrorPluginsIns };
